export default "//yastatic.net/s3/distribution/pythia/frontend/_/b4d7fc5ff3e7a06c3be3ab72f3ebaeb2.png";